<!-- <div class="chart-container">
    <canvas  id="MyChart" >{{ chart }}</canvas>
</div> -->
<div class="" style="width: 97%; margin: 0 auto">
    <div style="width: 100%;">
        <canvas style="width:100%"  id="myChart" width="900" height="250" #mychart></canvas>
    </div>
</div>